import {setPanelId_actionType, resetPanel} from "../constants"

const initialState = {id: "", type: "", content: {}}
const panelId = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case setPanelId_actionType:
            return state = payload
        case resetPanel:
            return state = initialState
        default:
            return state
    }
}

export default panelId